import React from "react";
import PropTypes from "prop-types";
import ReactMarkdown from "react-markdown";
import TextBlock from "./TextBlock";

/**
 * MarkdownBlock: props => React element
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * Content block that renders markdown-formatted
 * text
 *
 * @param {*} props
 */
const MarkdownBlock = props => (
  <div>
    {props.isReadOnlyMode ? (
      <ReactMarkdown>{props.block.text}</ReactMarkdown>
    ) : (
      <TextBlock
        {...props}
        placeholder={"manuscript.blocks.markdown.placeholder"}
      />
    )}
  </div>
);

MarkdownBlock.propTypes = {
  /**
   * block: {text}
   * Contains the content block information
   */
  block: PropTypes.shape({
    text: PropTypes.string
  }).isRequired,

  /**
   * isReadOnlyMode: Boolean
   * True if the block is read-only
   */
  isReadOnlyMode: PropTypes.bool.isRequired,

  /**
   * onChange: updatedBlock => ()
   * Passes on a block update to the higher-level component
   */
  onChange: PropTypes.func.isRequired
};

export default MarkdownBlock;



// WEBPACK FOOTER //
// ./src/modules/editor/manuscript/blocks/text/MarkdownBlock.js